import { render, staticRenderFns } from "./picComponent.vue?vue&type=template&id=6ee4041a&scoped=true&"
import script from "./picComponent.vue?vue&type=script&lang=js&"
export * from "./picComponent.vue?vue&type=script&lang=js&"
import style0 from "./picComponent.vue?vue&type=style&index=0&id=6ee4041a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee4041a",
  null
  
)

export default component.exports